"use clent";

import React from "react";
import "./styles.css";
import "../common.css";

export const InfoUnitMobiles = ({
	title,
	text = ["asd", "asdasfg", "asdflkca", "asdjkanf"],
	textColor = "#242323",
	picture,
	picture2,
	picture3,
	picture4,
	picture5,
	picture6,
	picture7,
	picture8,
	variant,
}) => {
	return (
		<div className="infowrapper" style={{ color: textColor }}>
			<div className="textblock">
				<div className="infotitle">{title}</div>
				{text.map((unit) => (
					<div>{unit}</div>
				))}
			</div>

			{variant === "grid" ? (
				<div className="infomobile__grid">
					{picture ? <img src={picture} alt="" /> : <div></div>}
					{picture2 ? <img src={picture2} alt="" /> : <div></div>}
					{picture3 ? <img src={picture3} alt="" /> : <div></div>}
					{picture4 ? <img src={picture4} alt="" /> : <div></div>}
					{picture5 ? <img src={picture5} alt="" /> : <div></div>}
					{picture6 ? <img src={picture6} alt="" /> : <div></div>}
					{picture7 ? <img src={picture7} alt="" /> : <div></div>}
					{picture8 ? <img src={picture8} alt="" /> : <div></div>}
				</div>
			) : variant === "system" ? (
				<div className="infosystems">
					<img src={picture} alt="" />
					<img src={picture2} alt="" />
					<img src={picture3} alt="" />
					<img src={picture4} alt="" />
					<img src={picture5} alt="" />
				</div>
			) : (
				<div className="infomobiles">
					<img src={picture} alt="" />
					<img src={picture2} alt="" />
					<img src={picture3} alt="" />
					<img src={picture4} alt="" />
				</div>
			)}
		</div>
	);
};
